module.exports = __webpack_public_path__ + "img/oirs.18185b9a.png";